module.exports = __webpack_public_path__ + "video/500_KMSAT15_2022_Common_Digital_Attacks-Phishing.a5b412c2.vtt";